exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.FavoriteButton{display:flex\n}\n.FavoriteButton>:first-child{padding:10px;margin:-10px -8px -10px -10px\n}\n.FavoriteButton .action-counter{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none\n}\n.FavoriteButton .interactive .svg-inline--fa{animation-duration:.6s\n}\n.FavoriteButton .interactive:hover .svg-inline--fa,.FavoriteButton .interactive.-favorited .svg-inline--fa{color:orange;color:var(--cOrange, orange)\n}", ""]);

// exports
